
// Libraries
import { Component, Vue, Prop } from "nuxt-property-decorator";
import { ButtonText } from "~/operations/messages";

// Components
import RouterLink from "~/components/atoms/text/RouterLink.vue";

@Component({
  components: {
    RouterLink,
  },
})
export default class AddressMolecule extends Vue {
  @Prop({ default: "Adresse" }) title: string;
  @Prop() name: string;
  @Prop() role: string;
  @Prop() company: string;
  @Prop() street: string;
  @Prop() streetNumber: string;
  @Prop() zipcode: string;
  @Prop() city: string;
  @Prop() email: string;
  @Prop() phone: string;
  @Prop() fax: string;
  @Prop() agbFileUrl: string;
  @Prop() withdrawalFileUrl: string;
  @Prop() imprint: string;
  @Prop() vatId: string;
  @Prop({ default: true, type: Boolean }) hasImprintToShow!: boolean;
  @Prop({ default: false, type: Boolean }) hasAGB!: boolean;
  @Prop({ default: false, type: Boolean }) hasWithdrawal!: boolean;

  ButtonText = ButtonText;

  showImprint = false;

  toggleImprint() {
    this.showImprint = !this.showImprint;
  }

  checkForValidPath(url) {
    if (url === null || !url) return null;
    const URLArray = url.split("/");
    if (URLArray[URLArray.length - 1] === "null") return null;
    return true;
  }
}
